import React from 'react';
import { useIntl } from 'react-intl';
import languageCodeNames from '~/languageCodeNames.json';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const languageCodes = Object.entries(languageCodeNames).map(([key, value]) => ({
  key,
  ...value,
}));

export const getLanguageNameFromLanguage = (
  language: Record<string, string> | null,
  locale: string
) => (language ? `${language[locale]} (${language.key})` : '');

type LanguageAutocompleteFieldProps = {
  input: {
    value: string;
    onChange: (languageKey: string | null) => void;
  };
  label: React.ReactNode;
  languageCodes?: Array<{ key: string }>;
};

export const LanguageAutocompleteField = (
  props: LanguageAutocompleteFieldProps
) => {
  const intl = useIntl();
  const allLanguageCodes = props.languageCodes || languageCodes;
  const handleChange = (value: { key: string } | null) =>
    props.input.onChange(value ? value.key : null);
  const defaultSelectedItem = props.input.value
    ? {
        ...allLanguageCodes.find(
          (language) => language.key === props.input.value
        ),
        key: props.input.value,
      }
    : undefined;
  return (
    <Autocomplete
      disablePortal
      defaultValue={defaultSelectedItem}
      id="language-autocomplete-field"
      options={allLanguageCodes}
      onChange={(event, value) => {
        handleChange(value);
      }}
      getOptionLabel={(option) =>
        getLanguageNameFromLanguage(option, intl.locale)
      }
      renderInput={(params) => <TextField {...params} label={props.label} />}
    />
  );
};

export default LanguageAutocompleteField;
